import moment from 'moment'
import { Booked } from '../../../core/enum/product-order-status-type';

const LEADS_MODULE = 23

export const DashboardUnclaimedWorkOrdersContainerComponent = {
    template: `
        <h1 class="page-header"
            ng-if="$ctrl.workOrders.length">Unclaimed Work Orders</h1>
        <div class="alert alert-info"
            ng-if="!$ctrl.loaded">
            Loading additional data&hellip;
        </div>
        <apex-dashboard-unclaimed-work-orders ng-if="$ctrl.loaded && $ctrl.workOrders.length"
                                              work-orders="$ctrl.workOrders"
                                              on-assign="$ctrl.onAssignEmployee($event)">
        </apex-dashboard-unclaimed-work-orders>`,
    require: {
        dashboardContext: "^apexDashboardContent"
    },
    controller: class DashboardUnclaimedWorkOrdersContainer {
        constructor($uibModal, $q, icdOfficeService, workOrderService, utilityService) {
            'ngInject'
            this.$uibModal = $uibModal
            this.$q = $q
            this.icdOfficeService = icdOfficeService
            this.workOrderService = workOrderService
            this.utilityService = utilityService
            this.loaded = false
        }

        $onInit() {
            const icdOffices = this.loadIcdOffices()
            const workOrders = this.workOrderService.retrieveWorkOrders({
                // The work order is unclaimed if not linked to an employee.
                //TODO: Paging to avoid unbounded data use.
                hasEmployee: false,
                // Treat work orders older than 1 month as too old to be relevant.
                modifiedSince: moment().add(-1, "month").format("YYYY-MM-DD")
            })

            this.$q.all([icdOffices, workOrders])
                .then(([icdOffices, workOrders]) => {
                    workOrders.forEach(workOrder => hydrateWorkOrder(workOrder, icdOffices))
                    this.workOrders = workOrders
                    this.loaded = true

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: this.workOrders.length,
                            count: this.workOrders.length
                        })
                    }
                })
        }

        onAssignEmployee({ workOrder }) {
            this.$uibModal.open({
                component: "apexAssignWorkOrderEmployeeModal",
                resolve: {
                    workOrders: function () {
                        return [workOrder];
                    }
                },
                windowClass: 'xx-dialog pagespinner',
                size: 'lg',
                backdrop: 'static'
            }).result
                .then(employee => this.claimWorkOrder(workOrder, employee))
                .catch(function (ex) {
                    if (ex !== 'cancel') {
                        throw ex;
                    }
                });
        }

        loadIcdOffices() {
            return this.icdOfficeService.retrieveIcdOffices({ moduleID: LEADS_MODULE }) // Only show offices under the leads module.
                .then(icdOffices => {
                    icdOffices.forEach(formatIcdOffice);
                    this.icdOffices = icdOffices.sort(function (a, b) {
                        return a.OwnerClientName < b.OwnerClientName ? -1 : 1
                    });
                    return this.icdOffices;
                });
        }

        claimWorkOrder(workOrder, employee) {
            const orderClaimed = this.workOrderService.patchWorkOrder(workOrder.WorkOrderID, {
                ChangeWorkOrderEmployee: {
                    WorkOrderID: workOrder.WorkOrderID,
                    EmployeeID: employee.Id
                }
            });
            orderClaimed.then(() => {
                // Remove the work order from the list.
                this.workOrders = this.workOrders.filter(function (p) {
                    return p.WorkOrderID !== workOrder.WorkOrderID;
                });
            });
            return orderClaimed;
        }
    }
}

function formatIcdOffice(icdOffice) {
    icdOffice.OwnerClientName = icdOffice.OwnerName + " - " + icdOffice.IcdCorporationName;
}

function hydrateWorkOrder(workOrder, icdOffices) {

    workOrder.IcdOffice = icdOffices.filter(function (office) {
        return office.Id === workOrder.IcdOfficeID;
    })[0];

    const statusDates = workOrder.ProductOrders.reduce(function (statusDates, productOrder) {
        productOrder.StatusHistory
            .filter(change => !statusDates[change.Status.ProductOrderStatusType]
                || change.EffectiveDate > statusDates[change.Status.ProductOrderStatusType])
            .forEach(change => {
                statusDates[change.Status.ProductOrderStatusType] = change.EffectiveDate;
            });
        return statusDates;
    }, {});
    workOrder.statusDates = statusDates;
    workOrder.appointmentDate = statusDates.Booked; //TODO: Distinguish between booked (no appointment) and booked (appointment scheduled)
    workOrder.installedDate = statusDates.Installed;
    workOrder.cancelledDate = statusDates.Cancelled;
    workOrder.disconnectedDate = statusDates.Disconnect;

    const statusHistory = workOrder.ProductOrders.map(p => p.StatusHistory)
        .reduce((a, b) => a.concat(b))

    const nonBookedStatuses = statusHistory.filter(history => history.Status.ProductOrderStatusType !== Booked.key)

    //Non-booked custom details will take priority
    const customDetailsStatus = nonBookedStatuses.length > 0 ? nonBookedStatuses.sort(sortByEffectiveDate)[0]
        : statusHistory.sort(sortByEffectiveDate)[0];
    workOrder.CustomDetails = JSON.parse(customDetailsStatus.CustomDetailsJson);
    workOrder.Address = !workOrder.Lead ? "" : formatAddress(workOrder.Lead.Address);
}

function formatAddress(address) {
    return (address.StreetLine1 || "")
        + " " + (address.StreetLine2 || "")
        + " - " + (address.PostalCode || "")
}

function sortByEffectiveDate(a, b) {
    return new Date(b.EffectiveDate) - new Date(a.EffectiveDate);
}
